
<div class="mt-0 w-100" style="padding-right: 75px;">
    <v-app-bar color="white" elevation="0"  height="45">
        <v-app-bar-nav-icon
            @click="drawer=true"
            class="primary--text"
            style="margin-top: -2px"
        />
        <v-toolbar-title class="primary--text">{{ title }}</v-toolbar-title>

        <c-app-home-search
            v-if="enableSearch"
            class="ml-3"
            :categories="categories"
            :search-on-focus="searchOnFocus"
        />

        <slot name="search" />

        <v-spacer v-if="enableSearch" />

        <div class="float-right" style="display: flex">
            <nav-user-menu />
        </div>
    </v-app-bar>

    <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
    >
        <c-app-side-drawer @close="onCloseSide ()" />
    </v-navigation-drawer>
</div>
